import React from 'react';
import {
    Box,
} from '@mui/material';

const PolicyTags = ({policyData}) => {
    
    return (
        <Box>
            {policyData?.policy?.keywords && policyData?.policy?.keywords?.length>0 && (<>{<h3 className="sectionHeading">KEY WORDS</h3>}
            <div className="preview-header-section">
                <p>{policyData?.policy?.keywords?.join(', ')}</p>
            </div></>)}
        </Box>
    )

}

export default PolicyTags;